import { render } from "./BeijiaoDigitalMuseumPage.vue?vue&type=template&id=2974112c&scoped=true"
import script from "./BeijiaoDigitalMuseumPage.vue?vue&type=script&lang=js"
export * from "./BeijiaoDigitalMuseumPage.vue?vue&type=script&lang=js"

import "@/assets/css/cases.css?vue&type=style&index=0&id=2974112c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2974112c"]])

export default __exports__